export default "/images/coop-armadores-logo.png?824462429bc16c2d8efdea902005ab3f";